import React from 'react';
import { useAuth } from '@repo/common';
import PersonalInfo from './PersonalInfo/PersonalInfo';
import JourneyGoal from './JourneyGoal/JourneyGoal';
import CompanyInfo from './CompanyInfo/CompanyInfo';

const BUSINESS_ROLES = new Set([
  'E',
  'ROLE_E',
  'EMPLOYER',
  'ROLE_EMPLOYER',
  'EMPLOYEE',
  'ROLE_EMPLOYEE',
]);

const MyProfile = () => {
  const { user } = useAuth();
  const isBusiness = BUSINESS_ROLES.has(
    String(user?.role ?? '').toUpperCase(),
  );

  if (isBusiness) {
    return <CompanyInfo />;
  }

  return (
    <div className='flex flex-col tabletH:max-w-[568px] justify-center items-start gap-[40px] tabletH:gap-0'>
      <PersonalInfo />
      <JourneyGoal />
    </div>
  );
};

export default MyProfile;
